// @flow
import * as React from 'react';
import { withRouter, type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectClient } from './clientsActions';
/*
 * This component will harvest the client id from a url parameter on mount.
 * if the client_id is set we strip it and replace the route
 * we do not replace the client_id in search results
 */
const clientIdRegex = /client_id=([0-9]+)/;

type StateProps = { clientId: Id };
type Props = {
  children: Function,
  selectClient: typeof selectClient,
} & ContextRouter &
  StateProps;

type State = {
  isMounted: boolean,
};

class ClientFromUrl extends React.Component<Props, State> {
  state = { isMounted: false };

  componentDidMount() {
    const { location, history } = this.props;
    const match = clientIdRegex.exec(location.search);

    if (Array.isArray(match)) {
      const clientId = match[1];

      if (+this.props.clientId !== +clientId) {
        this.props.selectClient(+clientId);
      }
      !isResultsPage(location.pathname) && history.replace(location.pathname);
    }

    this.setState({
      isMounted: true,
    });
  }

  render() {
    return this.state.isMounted ? this.props.children() : null;
  }
}

export default withRouter(
  connect(state => ({ clientId: state.clients.currentClient }), {
    selectClient,
  })(ClientFromUrl)
);

function isResultsPage(location: string): boolean {
  return location.indexOf('/results') > 0;
}



// WEBPACK FOOTER //
// ./src/containers/client/ClientFromUrl.js